import { useDispatch } from 'react-redux';

import { showContextMenu } from 'redux/mode/actions';

import Icon, { IconType } from 'components/Icon';

import * as S from './styles';
import { Divider } from '../styles';
import { useTheme } from 'styled-components';
import { MenuItem } from 'menu/MenuItem';

export interface HeaderProps {
	label: string;
	iconType?: IconType;
	menuItems?: MenuItem[];
}

const Header = ({ label, iconType, menuItems }: HeaderProps) => {
	const theme = useTheme();
	const dispatch = useDispatch();

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------	const onContextMenu = async (e: React.MouseEvent, frame: Frame) => {
	const onContextMenu = async (e: React.MouseEvent) => {
		if (!menuItems) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX + 5, y: e.clientY },
					menuItems,
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<>
			<Divider />
			<S.Base onContextMenu={(e) => onContextMenu(e)}>
				<S.Icon>
					{iconType ? (
						<Icon type={iconType} width={16} height={16} color={theme.gray['1000']} />
					) : null}
				</S.Icon>
				<S.Label>{label}</S.Label>
			</S.Base>
		</>
	);
};

export default Header;
